import {Presenter} from '../../support/with_presenter';
import {Subscription} from 'rxjs';
import {ToggleTokenSocket} from '../../network/toggle_token_socket';
import {runInAction} from 'mobx';

export class ToggleTokenPresenter implements Presenter {
    public isTokenVisible: boolean = false;

    private subscription: Subscription | undefined;

    constructor(private toggleTokenSocket: ToggleTokenSocket, private raceId: string) {}

    public mount(): void {
        this.subscription = this.toggleTokenSocket.getForRaceId(this.raceId).subscribe((data) => {
            runInAction(() => {
                this.isTokenVisible = data.isTokenVisible;
            });
        });
    }

    public unmount(): void {
        if (this.subscription !== undefined) {
            this.subscription.unsubscribe();
        }
    }

    public setIsTokenVisible = (isTokenVisible: boolean) => {
        this.toggleTokenSocket.toggleForRaceId(this.raceId, isTokenVisible);
    };
}
